import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Row } from 'reactstrap';
import { RootReducerState } from 'src/store/reducers';
import FeatherIcon from "feather-icons-react";
import { hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasDealerSubuserRoleHandler, hasFranchiseRoleHandler, hasFranchiseSubuserRoleHandler } from 'src/helpers/common_helpers';
import { API } from 'src/util/api';
import { getDefectivePartByJobId } from 'src/store/actions';
import Button from 'src/components/UI/Button';
import { useToast } from 'src/components/Common/ReactToaster';
import { toast } from 'react-toastify';
import JobsheetScanner from 'src/components/Common/Scanner/JobsheetScanner';

const DefectivePartModalForList = ({scanParts,setScanParts,jobId,setShowDefectivePart,jobPrefix,onScuuessDefectivePartScan=()=>{},number}:any) => {
    const { profile } = useSelector((state: RootReducerState) => state.profilesReducer);
    const { defectivePartsData } = useSelector((state: RootReducerState) => state.jobsheetReducer);
    const [openScanner, setOpenScanner] = useState<boolean>(false);
    const numRef = useRef<any>(null)
    const dispatch = useDispatch();
    const { showToast } = useToast();
    const handleKeyPress = (e: any) => {
      e?.preventDefault();

    let toScan = numRef?.current ? numRef?.current?.value?.split(" ")?.join("") : "";
    if(number && toScan != number){
      return showToast(`Please scan the correct SKU number: ${number}`, { type: "error" });
    }
    console.log("defectivePartsData",defectivePartsData);
    const currentUser  = profile?.extraProperties?.UserType
    let alreadyScannedParts = defectivePartsData?.filter((data:any)=>data?.isDeleted != true && data?.userType == currentUser)?.map((data:any)=>data.number)
    if(alreadyScannedParts.includes(toScan)){
       numRef.current.value = ""; 

        return showToast('SKU number already scanned', { type: "error" });
    }
    if (!toScan) return;
    debugger
      let profileData = profile
      setScanParts((prev:any)=>[...prev,{
        number:toScan,
        id:0,
        "locationName": profile?.extraProperties?.Address,
      "dealerId": profile?.extraProperties?.DealerId,
      "franchiseId": profile?.extraProperties?.FranchiseId,
      "employeeId": profile?.extraProperties?.MelEmployeeId,
      "customerId": profile?.extraProperties?.CustomerId,
      "userType": profile?.extraProperties?.UserType,
      jobPrefix:jobPrefix

      }]);
      numRef.current.value = ""; 
  };

 const hasDelete = (data:any)=>{
      if(data.userType == "Employee" && hasAdminOrEmployeeRoleHandler()){
        return true
      }else if((data.userType == "Franchise" || data.userType == "FranchiseSubUser") && (hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler())){
        return true
      }else if((data.userType == "Dealer" || data.userType == "DealerSubUser" ) &&( hasDealerRoleHandler() || hasDealerSubuserRoleHandler())){
        return true
      }else if(data.userType == "Customer" && hasCustomerRoleHandler()){
        return true
      }else{
        return false
      }
    }
    
      const handleRemoveParts = (id: number,idx:any) => {
        debugger
        if(id){
          try{
            const response = API.defectivePartDeleteApi(id)
            dispatch(getDefectivePartByJobId(jobId))
          }catch(e:any){

          }
        }else{
          const RemoveParts = scanParts.filter((item: any, index: number) => index !== idx);
          setScanParts(RemoveParts);
        }
      };
    
    const handleSubmit = async () => {
  try {
    let payload = {
      defectivePartList: scanParts?.map((val: any) => ({
        number: val.number,
        id: val.id,
        isDealerUpdate:(val.id == 0 && (hasDealerRoleHandler() || hasDealerSubuserRoleHandler())) ? true : false,
        jobId: jobId,
        locationName: val.locationName,
        dealerId: val.dealerId,
        franchiseId: val.franchiseId,
        employeeId: val.employeeId,
        customerId: val.customerId,
        userType: val.userType,
        jobPrefix:val.jobPrefix
      })),
    };

    // Await both API calls
    await API.defectivePartCreate(payload, jobId);
    await API.defectivePartCreateForJob(payload);

    // Only dispatch after both API calls succeed
    dispatch(getDefectivePartByJobId(jobId));
    setShowDefectivePart(false)
    showToast("Defective Parts Updated Successfully", { type: "success" });
    if(typeof onScuuessDefectivePartScan === "function"){
      onScuuessDefectivePartScan()
    }
  } catch (e: any) {
    debugger;
    showToast(e?.message || "Something went wrong", { type: "error" });
    if(typeof onScuuessDefectivePartScan === "function"){
      onScuuessDefectivePartScan()
    }
  }
};

 const setScanFromParent = (text:any) => {
    // let alreadyScanned = props.scanParts?.some((val:any)=>val.number == text);
    // if (alreadyScanned) {
    //   numRef.current.value = ""; 

    //   return showToast('SKU number already scanned', { type: "error" });
    // }
    setScanParts((prev:any)=>[...prev,{
      number:text,
      id:0,
      "locationName": profile?.extraProperties?.Address,
      "dealerId": profile?.extraProperties?.DealerId,
      "franchiseId": profile?.extraProperties?.FranchiseId,
      "employeeId": profile?.extraProperties?.MelEmployeeId,
      "customerId": profile?.extraProperties?.CustomerId,
      "userType": profile?.extraProperties?.UserType,
      jobPrefix:jobPrefix
    }]);
  }

 const scannerContainer = () => {
        return <JobsheetScanner visible={openScanner} onHide={() => setOpenScanner(false)} scanParts={scanParts} setScanParts={setScanFromParent}/>
      }

  const openScannerHandler = () => {
    setOpenScanner(true)
  }

  return (
    <div>
        <Card className="pe-0 ps-0 mb-0 border-leftrigh-none">
        <div className="dealer-title-header font-size-15 border-bottom">
          Add Defective Part
        </div>
        {openScanner && scannerContainer()}
        <CardBody className="p-0">
          <div className="px-3 pb-3">
            <Row>
              <div className="custom-scan-input" style={{ width: "300px" }}>
                <div className="inp-icon scan-here">
                  <FeatherIcon icon="search" className="icon-lg left-icon" />
                  <input
                    className="icon-input"
                    type="text"
                    placeholder="Scan SKU here"
                    disabled={false}
                    required={false}
                    ref={numRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === "Tab") {
                        handleKeyPress(e);
                      }
                    }}
                  />
                  <FeatherIcon
                    icon="camera"
                    className="icon-lg right-icon pointer"
                    onClick={openScannerHandler}
                  />

                </div>
              </div>
            </Row>
            <Row>{scanParts.length>0 &&
            <>
                <Card className='mt-3'>
                <div className="mt-2 text-bold">Scanned Sku</div>
                    <CardBody>
                    <div className="p-chips p-component p-inputwrapper p-inputwrapper-filled custom-chip">
                    <ul className="p-inputtext p-chips-multiple-container p-variant-filled">
                        {
                        scanParts.length > 0 && (
                        scanParts.map((item: any, index: number) => (
                          <li key={index} className="p-chips-token">
                            <span className="p-chips-token-label">{item.number}</span>
                           {hasDelete(item) && <FeatherIcon icon="x-circle" className="p-icon p-chips-token-icon" onClick={() => handleRemoveParts(item.id ? item.id : 0 , index)} />}
                          </li>
                        ))
                    )}
                    </ul>
                        </div>
                    </CardBody>
                </Card>
                </>
}
            </Row>
            <Row>
              <div></div>
            </Row>
          </div>
        </CardBody>
        {scanParts?.length >0 &&
        <div className="d-flex justify-content-end">

            <Button
                className="btn-secondary me-2 btn-secondary-shadow"
                label={ "Cancel"}
                onClick={() => {
                    setShowDefectivePart(false)
                }}
                type="button"
            />
        <Button
            className="btn-primary me-2 btn-primary-shadow"
            label={ "Update"}
            onClick={() => {
                handleSubmit()
            }}
            type="button"
        />
        </div>
        }
      </Card>
    </div>
  )
}

export default DefectivePartModalForList